import { ApplicationState } from '@store/store';

export const qrRegisteredSelector = (store: ApplicationState) => store.qrCode.qrRegistered;

export const qrCodeRegisterStatus = (store: ApplicationState) => store.qrCode.status;
